import { Box } from '@material-ui/core';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { SIGNIN_ROUTE } from '../../routes/routes';
import { logOut } from './SigninStore/signinSlice';

const LogoutScreen = ({ children }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const handleLogOut = () => {
    dispatch(logOut());
    history.push(SIGNIN_ROUTE);
  };
  return <Box onClick={handleLogOut}>{children}</Box>;
};

export default LogoutScreen;
